import { PreguntaCatalogo } from "./catalogo.model";

export enum TipoTarificacionProyectoVc {
    COLECTIVA = 'COLECTIVA',
    SVG = 'SVG',
    VIDA = 'VIDA',
    PRECIO_FIJO = 'PRECIO_FIJO'
}
export interface PackProyectoConfig {
    tipoTarificacionProyectoVc: TipoTarificacionProyectoVc;
    codProductoVc: string;
    codCia?: string;
    codRamo?: string;
    codModa?: string;
    codSubmoda?: string;
    codColectiva?: string;
    camposProducto?: CampoProductoVC[];
    mensajeTarificacion?: string;
    enlaces?: PacksEnlaces[];
}

export interface PacksEnlaces {
  txtTitulo: string;
  numOrden: number;
  tipoAperturaUrl: string;
  url: string;
}

export interface PackConfig {
    configsProyectos: PackProyectoConfig[];
}

export interface PackProducto {
    idPack?: number;
    codCia?: string;
    codRamo?: string;
    codModa?: string;
    codSubmoda?: string;
    codColectiva?: string;
    codProductoVc?: string;
    camposProducto?: CampoProductoVC[];
}

export interface PackIn {
    idRepositorio: number;
    proyecto?: ProyectoPackIn;
}

export interface ProyectoPackIn extends PackProducto {
    codProyecto: string;
    impPrimaTotal?: number;
}

export interface NuevoPackResponse {
    idPack: number;
}

export interface ActualizarProyectoPackIn extends ProyectoPackIn {
    codProyectoNuevo?: string;
    seleccionado?: boolean;
}

export interface GuardarPackIn {
    txtNif: string;
    txtNombre: string;
    txtApellido1: string;
    txtApellido2?: string;
}

export interface ContratarProyectoIn extends PackProducto {
    codProyecto: string;
    codPoliza: string;
    codCertificado: string;
}

export interface Pack {
    idPack: number;
    idRepositorio: number;
    codPaquete: string;
    txtNif: string;
    txtNombre: string;
    txtApellido1: string;
    txtApellido2?: string;
    proyectos: PackProyecto[];
}

export interface PackProyecto extends PackProducto {
    idProyecto?: number;
    codProyecto?: string;
    txtProyecto?: string;
    codPoliza?: string;
    codCertificado?: string;
    impPrimaTotal?: number;
    impPrimaPrimerRec?: number;
    impPrimaRecSucesivos?: number;
    esPrincipal?: boolean;
    esSeleccionado?: boolean;
    esDescuento?: boolean;
    urlImagen?: string;
    urlRedireccion?: string;
}

export interface ProyectoProductoVC {
    titulo?: string;
    mensaje?: string;
    proyectoVC: PackProyecto;
    proyectoDescuentoVC?: PackProyecto;
    descuento?: DescuentoProductoVc;
    configProyecto?: PackProyectoConfig;
}

export interface CampoPackProducto {
    codCampo: string;
    codCampoDestino: string;
    valorDefecto: string;
    visible: boolean;
    codFormulaValorDefecto?: string;
}

export interface CampoProductoVC extends CampoPackProducto {
    valor?: string;
    preguntaCatalogo?: PreguntaCatalogo;
}

export interface NuevoProyectoPackEvent {
    idPack: number;
    codProductoVentaCruzada: string;
}

export interface ModificarProyectoPackEvent {
    idPack: number;
    codProductoVentaCruzada: string;
    codProyecto: string;
}

export interface EliminarProyectoPackEvent {
    idPack: number;
    codProductoVentaCruzada: string;
}

export interface DescuentosVC {
    descuentosVc?: DescuentoProductoVc[];
}

export interface DescuentoProductoVc {
    codProductoVc: string;
    descuento: number;
    tipoDescuento: string;
    codColectiva: string;
}

export interface DescuentosVcIn {
    idPack: number;
    listaProyectosConfig: PackProyectoConfig[];
}

export interface TarificacionRapidaIn {
  idPack: number;
  codCia: string;
  codRamo: string;
  codModa: string;
  codSubmoda: string;
  codColectiva: string;
  listaCampos: CampoProductoValor[];
}

export interface CampoProductoValor {
  codCampo: string;
  valor: string;
}

export enum EstadoDescuentosVC {
    SIN_DESCUENTOS = 'SIN_DESCUENTOS',
    DISPONIBLES_SIN_PROYECTO = 'DISPONIBLES_SIN_PROYECTO',
    DISPONIBLES_CON_PROYECTO = 'DISPONIBLES_CON_PROYECTO'
}